// THE SAVE/APPLY STATE, AS ITS OWN COMPONENT.
//
// It lives outside ModelTracking for a mechanical reason as well as a
// tidy one: eslint-plugin-react-hooks counts code paths through the
// WHOLE component, and that file is big enough that a handful of extra
// ternaries in its JSX overflows the counter and reports "React Hook
// called conditionally" at unrelated earlier hooks. A previous build
// was lost to exactly that. Conditional text belongs in a helper.
//
// It renders NOTHING when there is nothing to say - the applied state
// is the quiet one, because a bar that is always there is a bar nobody
// reads.
import React from "react";
import { Button } from "antd";
import { previewWords } from "./scopeApplyState";

export default function ScopeApplyBar({ state, preview, onApply, canEdit = true }) {
  if (!canEdit) return null;
  if (!state || state.key === "applied") return null;
  const words = previewWords(preview);
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ color: "#b54708" }} data-testid="scope-apply-label">{state.label}</span>
      {words.line ? (
        <span style={{ color: "#6B7280" }} data-testid="scope-preview">
          {words.line}
          {words.warning ? <b style={{ color: "#b54708" }}> {words.warning}</b> : null}
        </span>
      ) : null}
      {state.button ? (
        <Button
          size="small"
          type="primary"
          loading={state.key === "applying"}
          data-testid="scope-apply"
          onClick={onApply}
        >
          {state.button}
        </Button>
      ) : null}
    </span>
  );
}
